import { Injectable, OnDestroy } from "@angular/core";
import { ActiveUserProfilePromiseService, ActiveUser } from "shared/cubiq-services";
import { BfxDialogData } from "../../bfx-dialogs/models/bfx-dialog-data.model";
import { Subject, Subscription } from "rxjs";
import { BfxDialogCommand } from "../../bfx-dialogs/models/bfx-dialog-command.enum";
import { OEApiService } from "app/order-entry/services/oe-api.service";
import { NativeDesktopSupport } from "../../bfx-native-desktop/native-desktop-support";
import { UserAuthPromiseService } from "../../../shared/cubiq-services/auth/impl/UserAuthPromiseService";
import {
  ConnectionStatus,
  ConnectionStatusPromiseService,
  ConnectionStatusState,
} from "shared/broker-client-services";

@Injectable()
export class BFXLogoutWarningService implements OnDestroy {
  private activeUser: ActiveUser;
  private logoutWarningSubscription = new Subject<BfxDialogData>();
  public dialogCtrl$ = this.logoutWarningSubscription.asObservable();
  private warningMessages: Array<string> = [];
  private isConnected: boolean;
  private connectionEventSubscription: Subscription;

  constructor(
    private activeUserService: ActiveUserProfilePromiseService,
    private _userAuthService: UserAuthPromiseService,
    private oeApiService: OEApiService,
    private _connectionStatusService: ConnectionStatusPromiseService,
  ) {
    this.activeUserService.getActiveUserData().then((data: ActiveUser) => {
      this.activeUser = data;
    });

    this.connectionEventSubscription = this._connectionStatusService
      .getConnectionEvents()
      .subscribe((event: ConnectionStatus) => {
        //
        switch (event.getStatus()) {
          case ConnectionStatusState.CONNECTED: {
            this.isConnected = true;
          }
          default: {
            this.isConnected = false;
          }
        }
      });
  }

  ngOnDestroy(): void {
    if (this.connectionEventSubscription != null) {
      this.connectionEventSubscription.unsubscribe();
      this.connectionEventSubscription = null;
    }
  }

  public warnOnLogout(callback: Function) {
    if (!this.isConnected) {
      callback();
      return;
    }

    this._userAuthService
      .getLogoutWarnings(this.activeUser.isTrader(), this.oeApiService.hasOrdersInDI())
      .then((warnings: Array<string>) => {
        this.warningMessages = warnings;
        this.triggerWarning(callback);
      });
  }

  public triggerWarning(callback: Function) {
    let payload = {
      messages: this.warningMessages,
      title: "warning.title",
      showConfirmationMessage: false,
      showLogoutMessage: true,
      callback: callback,
    };
    let bfxDialogData: BfxDialogData = new BfxDialogData(
      BfxDialogCommand.DIALOG_GENERIC_WARN_OPEN,
      null,
      null,
      payload,
    );
    if (NativeDesktopSupport.isNativeDesktopContainer()) {
      let el: Element = window.document.body as Element;
      if (el != null) bfxDialogData["body"] = el;
    }
    this.logoutWarningSubscription.next(bfxDialogData);
  }
}
